export interface PermisoConfig {
  modulo: string;
  acciones: string[];
}

export const PERMISSIONS_CONFIG: PermisoConfig[] = [
  {
    modulo: "Prospectos",
    acciones: ["Ver todos", "Ver Propios", "Cambiar etapa", "Ver alertas", "Completar", "Subir", "Enviar", "Descargar", "Crear", "Editar", "Eliminar"]
  },
  {
    modulo: "Oportunidades",
    acciones: ["Ver todos", "Ver Propios", "Cambiar etapa", "Ver alertas", "Completar", "Subir", "Enviar", "Descargar", "Crear", "Editar", "Eliminar"]
  },
  {
    modulo: "Tareas y recordatorios",
    acciones: ["Ver todos", "Ver Propios", "Cambiar etapa", "Ver alertas", "Completar", "Subir", "Enviar", "Descargar", "Crear", "Editar", "Eliminar"]
  },
  {
    modulo: "Presupuestos",
    acciones: ["Ver todos", "Ver Propios", "Cambiar etapa", "Ver alertas", "Completar", "Subir", "Enviar", "Descargar", "Crear", "Editar", "Eliminar"]
  },
  {
    modulo: "Contratos",
    acciones: ["Ver todos", "Ver Propios", "Cambiar etapa", "Ver alertas", "Completar", "Subir", "Enviar", "Descargar", "Crear", "Editar", "Eliminar"]
  },
  {
    modulo: "Usuarios y roles",
    acciones: ["Ver Usuarios", "Crear Usuarios", "Editar Usuarios", "Asignar Roles", "Configurar Permisos"]
  },
  {
    modulo: "Reportes y dashboard",
    acciones: ["Ver Panel general", "Ver Panel Individual", "Acceder a reportes"]
  },
  {
    modulo: "Mailing y campañas",
    acciones: ["Crear", "Editar", "Eliminar", "Enviar", "Ver resultados"]
  },
  {
    modulo: "Pronóstico de ventas",
    acciones: ["Ver Propias", "Ver Generales", "Editar probabilidades"]
  },
  {
    modulo: "Metas",
    acciones: ["Crear", "Editar", "Eliminar", "Asignar", "Mover de Estado"]
  }
  
];